import { IFormPartnerBasicInfo } from 'legacy/lut/classes/models/partner360/IFormPartnerBasicInfo'
import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { CommitmentTypes } from 'legacy/lut/components/widgets/public/partner360/commitment/models'
import { IJbpSettings } from 'legacy/lut/features/partner360/jbpSettings'

import { IForm } from 'core-components/classes/models/IForm'
import { NotificationController } from 'core-components/library/popup'

import { generateProcess } from './generateProcess'

interface IGeneratePartnerPlan {
  setProgressPercentage: (value: number) => void
  item: IForm
  partnerId: string
  fyear: number
  programType: ProgramTypes
  setIsRefuseCurrentItem: (value: boolean) => void
  setIsBlockRefresh: (value: boolean) => void
  jbpSettings: IJbpSettings | undefined
  partnerInfo: IFormPartnerBasicInfo | undefined
}
export const generatePartnerPlan = async ({
  setProgressPercentage,
  item,
  programType,
  fyear,
  partnerId,
  setIsRefuseCurrentItem,
  setIsBlockRefresh,
  partnerInfo,
  jbpSettings,
}: IGeneratePartnerPlan) => {
  // Generate Partner Plan on PBM Acknowledgment
  if (item.CommitmentType === CommitmentTypes.PBM && partnerInfo) {
    setIsBlockRefresh(true)
    const isGenerateSuccess = await generateProcess({
      partnerId,
      fyear,
      setProgressPercentage,
      partnerInfoEntryId: partnerInfo.EntryId,
      generatePDFOnBackend: Boolean(jbpSettings?.generatePDFOnBackend),
      programType,
    })

    if (!isGenerateSuccess) {
      setIsRefuseCurrentItem(false)
      NotificationController.showError({
        message: 'Attachment save failed, commitment aborted, please, try again later.',
      })
    }
    setProgressPercentage(100)
    setIsBlockRefresh(false)

    return isGenerateSuccess
  }

  return true
}
